import * as React from "react"
import {
  SelectConnectedField,
  SelectConnectedFieldProps,
} from "gatsby-interface"
import { useVercelProjectsForSiteQuery } from "@modules/cdn/vercel/queries.generated"
import { vercelIntegrationConfig as text } from "@modules/locales/default.js"
import { normalizeVercelTeamId } from "../utils"

export type VercelProjectFieldProps = Omit<
  SelectConnectedFieldProps,
  "options"
> & {
  siteId: string
  teamId: string
}

export function VercelProjectField({
  siteId,
  teamId,
  ...rest
}: VercelProjectFieldProps) {
  const { data, loading } = useVercelProjectsForSiteQuery({
    variables: {
      siteId,
      teamId: normalizeVercelTeamId(teamId),
    },
    fetchPolicy: `cache-and-network`,
  })

  const projects = data?.nowProjectsForGatsbySiteId ?? []

  const projectOptions = React.useMemo<
    SelectConnectedFieldProps["options"]
  >(() => {
    return [{ value: ``, label: text.labels.selectProject }].concat(
      projects.map(({ name }) => ({
        value: name,
        label: name,
      }))
    )
  }, [projects])

  return (
    <SelectConnectedField
      options={projectOptions}
      disabled={loading}
      {...rest}
    />
  )
}
